var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-input',{staticClass:"d-inline-block mr-1",attrs:{"placeholder":_vm.placeHolder},model:{value:(_vm.debouncedSearch),callback:function ($$v) {_vm.debouncedSearch=$$v},expression:"debouncedSearch"}})}
var staticRenderFns = []

export { render, staticRenderFns }